import React, { useEffect, useState } from "react"
import useViewport from "@/hooks/useViewport"
import { isCanadaSite } from "@/utils/helper"

const Coach = props => {
  const {
    text,
    hide = false,
    showHeaderCoach = false,
    panelState,
    isOverlapping,
    displayKey = "",
    siteName = null,
  } = props || {}

  const [isShown, setIsShown] = useState(false)
  const [isSeen, setIsSeen] = useState(false)
  const device = useViewport()
  const [coachMarkPosition, setCoachMarkPosition] = useState({
    top: 0,
    left: 0,
    zIndex: 1,
  })
  const kohlerCanadaFlag = isCanadaSite(siteName)
  const exitClass = kohlerCanadaFlag ? "exit-coach-mark-canada" : null
  useEffect(() => {
    updateCoachMarkPosition()
    window.addEventListener("resize", updateCoachMarkPosition)
    return () => {
      window.removeEventListener("resize", updateCoachMarkPosition)
    }
  }, [device])

  const updateCoachMarkPosition = () => {
    let top
    let left
    if (showHeaderCoach) {
      const addCoachFirstChild = document
        ?.querySelector(".add-coach")
        ?.firstElementChild?.getBoundingClientRect()?.right
      const contentChange = addCoachFirstChild - 85

      if (device?.isExtraSmallScreen) {
        top = "110px"
        left = "65px"
      } else if (device?.isSmallScreen) {
        top = "115px"
        left = `85px`
      } else if (device?.isMediumScreen) {
        top = "110px"
        left = `${contentChange}px`
      } else {
        top = isOverlapping ? "115px" : "75px"
        left = `${contentChange}px`
      }
      setCoachMarkPosition({
        top: top,
        left: left,
      })
    }
  }
  useEffect(() => {
    if (!hide) setIsShown(true)
    else setIsShown(false)
  }, [])
  const conditionalCss = showHeaderCoach
    ? {
        top: coachMarkPosition.top,
        left: coachMarkPosition.left,
        zIndex: panelState ? 1 : 2,
      }
    : null

  useEffect(() => {
    const getCoachKey = window.localStorage.getItem("getCoachKey")
    if (
      getCoachKey &&
      Object.prototype.hasOwnProperty.call(JSON.parse(getCoachKey), displayKey)
    ) {
      setIsSeen(true)
    }
  }, [])

  const handlerModel = () => {
    const getCoachKeyVal = window.localStorage.getItem("getCoachKey")
    let keyVal = {}
    if (getCoachKeyVal) keyVal = JSON.parse(getCoachKeyVal)
    keyVal[displayKey] = "y"
    window.localStorage.setItem("getCoachKey", JSON.stringify(keyVal))
    setIsShown(false)
    setIsSeen(true)
  }

  return !isSeen && isShown && !hide ? (
    <div
      className={`coach-mark ${exitClass} `}
      data-testid="header-back-button"
      style={conditionalCss}
    >
      <span className="coach-text">{text}</span>
      <button className="close-button-coach" onClick={handlerModel}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
        >
          <path
            d="M10.7043 10L19.8599 19.2857L19.1556 20L10 10.7143L10.7043 10Z"
            fill="white"
          />
          <path
            d="M19.2957 10L10.1401 19.2857L10.8444 20L20 10.7143L19.2957 10Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  ) : null
}

export default Coach
